import React from "react";
import SbEditable from "storyblok-react";
import Label from "src/components/Label";
import Heading from "src/components/Heading";
import RichText from "src/utils/RichText";
import { LabelColour } from "src/utils/ColourUtilities";
import GetTeam from "/src/utils/GetTeam";
import WithLargeImagesTeamMember from "./WithLargeImagesTeamMember";

const WithLargeImages = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div id="our-team" className={`py-14 lg:py-28 px-6 bg-cloud`}>
        <div className="max-w-7xl mx-auto">
          <div class="mx-auto flex flex-col text-center items-center justify-center border-b border-midnight border-opacity-20">
          {blok.power_icon?.filename && (
            <div class="mb-5 lg:mb-7">
                            <img
              src={blok.power_icon.filename}
              alt={blok.power_icon.alt}
              className="w-10 h-10"
            />
            </div>
          )}
          <div className="text-midnight subtitle">{blok.label}</div>
          <Heading size="h2" className="text-midnight h2">
            {blok.title}
          </Heading>
          <div className="prose text-midnight max-w-prose lg:text-xl text-lg font-light lg:mt-8 mt-4">
            <RichText>{blok.description}</RichText>
          </div>
          </div>
          <div className="lg:mt-20 mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-8">
            {GetTeam().map((item) => (
              <WithLargeImagesTeamMember {...item} key={item.uuid} />
            ))}
          </div>
        </div>
      </div>
    </SbEditable>
  );
};

export default WithLargeImages;
